import React, { useState } from "react";
import toast from "react-hot-toast";
import { ApiCrearCargo, ApiEditarCargo } from "../../../api/cargos";

/** */
const CrearCargos = ({
  updateListFn,
  state,
  setState,
  type,
  setType,
  resetState,
}) => {
  const [loading, setlLoading] = useState(false);
  const fields = [
    { name: "pre_cod_cargo", label: "Codigo del Cargo" },
    { name: "pre_cargo", label: "Nombre del Cargo" },
  ];

  const onchange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const emptyFields = fields.filter((campo) => !state[campo.name]);

  const CrearFn = async () => {
    setlLoading(true);
    if (emptyFields.length > 0) {
      const mensajes = emptyFields.map(
        (campo) => `El campo "${campo.label}" no puede estar vacío.`
      );
      const mensajeError = mensajes.join("\n");
      toast.error(mensajeError, {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    const res =
      type === "save"
        ? await ApiCrearCargo(state)
        : await ApiEditarCargo(state);

    const datares = res;
    if (datares.sms === "ok") {
      toast.success(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setType("save");
      resetState();
      updateListFn();
    } else {
      toast.error(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    setlLoading(false);
  };

  return (
    <div>
      <div className="row mt-3 mb-4">
        <div className="col-md-6 col-lg-4  w-100">
          <div
            className=" bg-white  border-0 borde-tarjeta"
            style={{ height: "auto" }}
          >
            <div className="card-body m-0 p-0">
              <div className="w-100 bgfondo2 bordeabajo bordesombreado d-flex flex-column align-items-center d-flex justify-content-center py-3 px-3">
                <div className="w-100  d-flex justify-content-between align-items-center px-3">
                  <h5 className=" negrita card-title">
                    {type === "save" ? "Crear" : "Editar"} Cargo
                  </h5>
                  <div className="d-flex justify-content-between flex-row align-self-start">
                    <div className="d-flex justify-content-end ">
                      {loading ? (
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <button
                          type=""
                          className="bg-btn-vet bordesombreado"
                          onClick={() => CrearFn()}
                        >
                          <i className="fas fa-save mx-2"></i>
                          {type === "save" ? "Guardar" : "Editar"} Cargo
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row py-4 ">
                <div className="col-md-6">
                  <label className="py-2 negrita">Codigo del Cargo</label>
                  <input
                    type="text"
                    id="pre_cod_cargo"
                    name="pre_cod_cargo"
                    value={state.pre_cod_cargo}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite el código del cargo"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Nombre del Cargo</label>
                  <input
                    type="text"
                    id="pre_cargo"
                    name="pre_cargo"
                    value={state.pre_cargo}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite el nombre del Cargo"
                    onChange={onchange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrearCargos;
